module.exports = __webpack_public_path__ + "static/media/03 Generali Sprzęt Rolniczy Ustandaryzowany dokument.d2c22fae.pdf";